import BodyTextMedium from "./BodyTextMedium";
import Box from "./Box";
import PropTypes from "prop-types";
import React from "react";

function ContactBlock({ enquiry_type: enquiryType, intro, email }) {
  return (
    <Box>
      <BodyTextMedium uppercase fontWeight={700}>
        {enquiryType}
      </BodyTextMedium>
      <Box mt={[10, null, 14, null]} mb={[20, null, 36, null]}>
        <BodyTextMedium>{intro}</BodyTextMedium>
      </Box>
      <a href={`mailto:${email}`}>
        <Box
          hover="opacity: 0.5"
          transition="opacity 200ms"
          display="inline-block"
          mb={[15, null, 0, null]}
        >
          <BodyTextMedium underline uppercase>
            {email}
          </BodyTextMedium>
        </Box>
      </a>
    </Box>
  );
}

export default ContactBlock;

ContactBlock.propTypes = {
  enquiry_type: PropTypes.string.isRequired,
  intro: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
};
